import React from "react";
import {
  Headphones,
  TrendingUp,
  ShoppingBag,
  Banknote,
  HeartHandshake,
  Plane,
} from "lucide-react";

const cases = [
  {
    icon: Headphones,
    tag: "Support",
    title: "Tier-1 + Tier-2 resolution",
    body: "Deflect 80%+ of FAQs, refunds and status checks. Escalate the rest with full context.",
  },
  {
    icon: TrendingUp,
    tag: "Sales",
    title: "Inbound qualification, 24/7",
    body: "Qualify leads, book demos, answer pricing questions — without making the prospect wait.",
  },
  {
    icon: HeartHandshake,
    tag: "Success",
    title: "Proactive customer success",
    body: "Spot churn signals, trigger nudges, run renewal conversations at the right moment.",
  },
  {
    icon: ShoppingBag,
    tag: "E-commerce",
    title: "Order, return, recommend",
    body: "Track shipments, process returns, upsell based on order history — across WhatsApp and web.",
  },
  {
    icon: Banknote,
    tag: "Fintech",
    title: "Compliant financial support",
    body: "KYC-aware replies, transaction lookups and fraud triage — with PII redaction built-in.",
  },
  {
    icon: Plane,
    tag: "Travel",
    title: "Itinerary & booking assist",
    body: "Rebook, refund, reschedule — in the guest's language, at 3am local time.",
  },
];

export default function UseCases() {
  return (
    <section
      id="usecases"
      data-testid="usecases-section"
      className="relative py-28 md:py-40 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-wrap items-end justify-between mb-14 gap-6">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 mb-5">
              <span className="text-[11px] font-mono tracking-[0.2em] uppercase text-[#3DDFB3]">
                ── Use cases
              </span>
            </div>
            <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-white">
              Built for every{" "}
              <span className="italic">customer-facing</span> team.
            </h2>
          </div>
          <p className="max-w-md text-white/55 text-[15px] leading-relaxed">
            Teams at hyper-growth startups and Fortune 500s run millions of
            conversations on our agents — from first touch to final
            renewal.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cases.map((c, i) => (
            <div
              key={i}
              data-testid={`usecase-card-${i}`}
              className="card-surface p-7 group"
            >
              <div className="flex items-center justify-between mb-8">
                <div className="w-11 h-11 rounded-lg bg-white/[0.03] border border-white/10 flex items-center justify-center group-hover:border-[#7C5CFF]/40 transition-colors">
                  <c.icon className="w-5 h-5 text-white/80 group-hover:text-[#7C5CFF] transition-colors" />
                </div>
                <span className="pill bg-white/[0.03] border border-white/10 text-white/50 text-[10px]">
                  {c.tag}
                </span>
              </div>
              <h3 className="font-serif text-[24px] leading-[1.15] text-white mb-3">
                {c.title}
              </h3>
              <p className="text-white/55 text-[14.5px] leading-relaxed">
                {c.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
